
export const isTitleCase = value => /^[a-zA-Z\ ]*$/.test(value)
export const isAlphanumeric = value => /^[a-zA-Z0-9\ ]*$/.test(value)
export const isAlphanumericOrWhitespace = value => /^[\w\s\.]*$/.test(value)

export function toTitleCase(str) {
  return str.replace(
    /([A-Za-z0-9]+[-_]?)/g,
    function(txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1)
        .replace('-', ' ')
        .replace('_', ' ')
        .toLowerCase();
    }
  );
}

export function toKebabCase(str) {
  return str.replace(
    /([A-Za-z0-9]+ ?)/g,
    function(txt) {
      return txt.substr(0).replace(' ', '-').toLowerCase();
    }
  )
}

export function getRandomKebabCase(str='', exemptions=[]) {
  let ret = toKebabCase(str);
  while (exemptions.some(i => i === ret)) {
    ret = toKebabCase(str) + "-";
    for (let i = 0; i < 6; i++) {
      ret += String.fromCharCode(97+Math.floor(Math.random() * 26))
    }
  }
  return ret;
}

export function formatNumber(value) {
  if (Math.abs(value) <= 999) {
    return value.toFixed(0) + "";
  } else if (Math.abs(value) <= 99444) {
    return (value/1000).toFixed(1) + "K";
  } else if (Math.abs(value) <= 999444) {
    return (value/1000).toFixed(0) + "K";
  } else if (Math.abs(value) <= 99444444) {
    return (value/1000000).toFixed(1) + "M";
  } else {
    return (value/1000000).toFixed(0) + "M";
  }
}

export function formatPercentage(amount, total) {
  return ((100 * amount)/total).toFixed(0) + "%";
}